// Thin shim over Vite's import.meta.env. Isolated here so Jest can stub this
// module without import.meta syntax appearing in test-compiled CommonJS code.

// True under `pnpm dev` (Vite dev server). Statically replaced at build time.
export const isDev: boolean = import.meta.env.DEV

// Local-dev API key shared with the Go server (same env name). Vite is
// configured (envPrefix) to expose LOCAL_DEV_* vars to client code so a
// single .env entry drives both server and SPA. Empty/undefined in
// production builds; never embed in staging/prod.
export const localApiKey: string | undefined = import.meta.env.LOCAL_DEV_API_KEY

// True when the page is being served from a loopback host. Distinct from
// isDev — covers both `pnpm dev` (localhost:5100) AND the prod-style
// `vite build && go run` flow (localhost:8080). False on every real deploy.
// Used to gate the "local dev: API key required" splash so it fires in
// either local flow when LOCAL_DEV_API_KEY isn't configured.
export const isLocalhost: boolean =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]')
